import ProfileSelectorPage from '@/pages/auth/ProfileSelectorPage';
import { PATHS } from '@/constants/Paths';
import { useAuth } from '@/hooks/useAuth';
import { LoginState } from '@/types/auth/LoginState';
import React from 'react';
import { Navigate } from 'react-router';

/** Page de secours après login si la sélection automatique du profil échoue. */
const ProfileSelectorRoutePage: React.FC = () => {
  const { userInfo, pendingProfiles, pendingSelectionToken } = useAuth();
  const isLoggedIn = userInfo?.state === LoginState.LOGGED_IN;

  if (isLoggedIn) {
    return <Navigate to={PATHS.profile} replace />;
  }

  if (pendingProfiles.length > 1 && pendingSelectionToken) {
    return (
      <ProfileSelectorPage
        profiles={pendingProfiles}
        selectionToken={pendingSelectionToken}
        mode="login"
      />
    );
  }

  return <Navigate to={PATHS.auth.login} replace />;
};

export default ProfileSelectorRoutePage;
